import {
  AmountStatus,
  CertIDType,
  MainOrderStatus,
  MemberType,
  OccType,
  SourceChannelType,
  SubOrderStatus,
} from '@/config/constant';
import { IdataSource, Ipagination } from '@/utils';
import actionType from '../actions/order/actionType';

export interface IorderQueryItem {
  amountStatus?: 0 | 1 | 2 | null; // 0：正常，1：余额不足，2：已欠费
  arrivalTimeType?: 0 | 1 | 2 | null; // 0：今日，1：本周，2：下周）
  billStatus?: 0 | 1 | null; // 0：未结，1：已结
  commonCode?: string;
  occType?: 'DAY_USE' | 'TIME_RENT';
  resvNo?: string;
  roomTypeId?: number;
  sourceChannelId?: number;
  statusList?: Array<number>;
  textLike?: string;
}

export interface IorderItem {
  [x: string]: any;
  id?: number;
  extensionFlag?: boolean; // 续住明细
  balance?: number; // 实时余额
  checkinTime?: string; // 入住时间
  checkoutBusinessDate?: string; // 退房营业日
  checkoutTime?: string; // 退房时间
  commonCode?: string;
  customerOrigin?: '线下' | '会员' | '中介' | '协议公司';
  deposit?: number; // 押金
  expectedArrivalTime?: string; // 预抵日期
  expectedDepartureTime?: string; // 预离日期，含时间
  joinRoomId?: number; // 联房主键
  liquidatedDamages?: number; // 加收预订违约金
  masterMobile?: string; // 房主手机号
  masterName?: string;
  mobile?: string; // 预订人手机号
  name?: string;
  occDuration?: number; // 入住时长
  occType?: OccType.DayUse | OccType.TimeRENT | '多种';
  otaOrderNo?: string;
  priceStrategyId?: number; // 价格策略id
  recNo?: string; // 接待单编号
  remark?: string;
  resvNo?: string; // 预订单号
  roomId?: number;
  roomNo?: string;
  roomTypeId?: number;
  roomTypeName?: string;
  sourceChannelId?: number;
  status?: SubOrderStatus;
  roomPriceList?: Array<any>;
  occInfoList?: Array<any>;
  billStatus?: 0 | 1;
  priceChannel?: 'MT_ZL';
}

// 入住人信息
export interface IcustomerInfo {
  wyuid: string;
  accountType: string;
  id: number;
  commonCode?: string;
  certType?: number;
  certNo?: string; // 身份证
  leaveFlag?: boolean; // 是否离店
  // memberFlag?: boolean; // 是否会员
  memberType?: MemberType;
  mobile?: string;
  showMobile?: string;
  email?: string;
  showEmail?: string;
  name?: string;
  remainingBalance?: string; // 余额
  roomId?: number;
  roomNo?: string; // 房号
  resvNo?: string; // 预订单
  recNo?: string; // 接待单
  remark?: string; // 宾客备注
  canBuyCard?: boolean;
}

// 房间信息
export interface IroomInfo {
  id?: number;
  joinRoomNo?: string; // 联房号
  roomId: number; // 房间id
  roomNo?: string; // 房间号
  name?: string; // 房主人、预订人
  roomTypeName?: string;
  mainStatus?: number; // 区别：预订中状态只包含今天预订 1预订 2在住
  status?: SubOrderStatus; // 状态 1预订中、2预订取消、3入住中、4续住中、5已续住、6已退房
  channelOrderNo?: string; // 渠道单号
  checkinRemark?: string; // 入住备注
  extensionFlag?: boolean; // 是否续住
  checkinTime?: string; // 入住时间
  checkoutTime?: string; // 退房时间
  expectedDepartureTime?: string; // 预离时间
  occDuration?: string; // 入住时长
  memCount?: string; // 入住人数
  occType?: string; // 入住类型
  priceStrategyName?: string; // 计价策略
  remark?: string; // 预订备注
  sourceChannelType?: SourceChannelType;
  sourceChannelName?: string; // 客源渠道
  roomMasterFlag?: boolean; // 是否房主所在房间
  resvNo?: string; // 主单
  recNo?: string; // 子单（房间单）
  wyuId?: string; // 注意---大写
  updateTime?: number;
  priceChannel?: 'MT_ZL' | 'XC_ZL';
}

export interface IRentDayInfos {
  id?: number;
  editFlag?: 0 | 1; // 是否可以编辑 0否 1可
  price?: number; // 价格：分
  rentDate?: string; // 日期 yyyy-MM-dd
  priceChannel?: SourceChannelType | null;
}

// 房价信息
export interface IroomPrice {
  deposit?: number; // 押金
  roomId: number; // 房间id
  rentDayInfos?: Array<IRentDayInfos>;
  roomNo?: string; // 房间号
  roomTypeName?: string; // 房型名称
}

/*
 * 订单账务状态(0-账务已结，1-已欠费，2-预付款不足，3-押金使用中，4-无账务，5-账务正常)
 */
export type OrderBillState = 0 | 1 | 2 | 3 | 4 | 5;

export interface IorderBaseInfo {
  billOrderStatus?: AmountStatus; // 账务状态 0正常1余额不足2已欠费
  billStatus?: number; // 0未结 1已结
  noBillItem?: boolean; // true 无账务 false 有账务
  createTime?: number; // 订单创建时间
  resvNo?: string; // 订单号
  resvStatus?: MainOrderStatus; // 主订单状态
  ownerWyuid?: string; // 房主wyuid
  newAccountingStatus?: OrderBillState | number; // 订单账务状态(v1.9新增)
}

interface StaffState extends Ipagination {
  // 直连退单map
  otaOrderMap?: { [key: string]: Array<any> };
  // 能否更换房主
  isChangeMatser?: boolean;
  // 门店是否启用房卡
  isStartUseCard?: boolean;
  channelDataSource?: Array<IdataSource>;
  roomTypeDataSource?: Array<IdataSource>;
  // 列表
  orderList: Array<IorderItem>;
  // 主订单信息
  sourceChannelType: SourceChannelType;
  mainOrderStatus: MainOrderStatus;
  // 订单详情基本信息
  orderBaseInfo: IorderBaseInfo;
  // 宾客
  reserveCustomerList: Array<IcustomerInfo>;
  checkInCustomerList: Array<IcustomerInfo>;
  bookerRoomInfoList: Array<IroomInfo>;
  checkInRoomInfoList: Array<IroomInfo>;
  // 房间
  roomInfoList: Array<IroomInfo>;
  dayRangeDateList: Array<any>;
  dayPriceDataSource: Array<any>;
  hourRangeDateList: Array<any>;
  hourPriceDataSource: Array<any>;
  // 查房
  checkRoomLogList: Array<any>;
  orderListLoading: boolean;
  orderBaseInfoLoading: boolean;
  orderCustomerInfoLoading: boolean;
  orderRoomInfoLoading: boolean;
}

const initialState: StaffState = {
  otaOrderMap: {},
  isChangeMatser: false,
  isStartUseCard: false,
  orderList: [],
  sourceChannelType: null,
  mainOrderStatus: null,
  orderBaseInfo: {},
  reserveCustomerList: [],
  checkInCustomerList: [],
  bookerRoomInfoList: [],
  checkInRoomInfoList: [],
  roomInfoList: [],
  dayRangeDateList: [],
  dayPriceDataSource: [],
  hourRangeDateList: [],
  hourPriceDataSource: [],
  checkRoomLogList: [],
  orderListLoading: false,
  orderBaseInfoLoading: false,
  orderCustomerInfoLoading: false,
  orderRoomInfoLoading: false,
  pageNum: 1,
  pageSize: 50,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.CLEAR_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SAVE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_PAGINATION:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.TOGGLE_LOADING: {
      const loading = state[action.payload];
      return {
        ...state,
        [action.payload]: !loading,
      };
    }
    case actionType.RESET_PAGINATION:
      return {
        ...state,
        pageNum: 1,
        pageSize: 50,
        total: 0,
      };
    case actionType.EXTENDED_CHECKIN_DETAIL_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.LAST_NIGHT_AUDIT_TIME:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.CHANNEL_DATA_SOURCE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ROOM_TYPE_DATA_SOURCE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ALL_ROOM_TYPE_MAP:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.BILL_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SPLIT_ROOM_TYPE_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ORDER_RECEPTION_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ORDER_RECEPTION_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ORDER_RESERVATION_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ORDER_RESERVATION_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ORDER_DETAIL_BASE_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ORDER_DETAIL_CUSTOMER_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ORDER_DETAIL_ROOM_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.ORDER_DETAIL_CHECK_ROOM_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.STOTE_START_USE_CARD:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.IS_CHANGE_MASTER:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.OTA_CANCEL_LIST:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
